import { Injectable } from '@angular/core';
import { BaseService } from './base-service.service';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import {
  ApplicationTypeStatusBase,
  ApplicationTypeStatusGroup,
  SimpleUser,
} from '@intellio/shared/models';

@Injectable({
  providedIn: 'root',
})
export class ChangeStatusService extends BaseService {
  constructor(
    private httpClient: HttpClient,
    protected configService: AppConfigService,
    protected authService: AuthService
  ) {
    super(httpClient, configService, authService);
  }

  updateStatusChange(
    appId,
    newStatusId,
    fileNames,
    postBody,
    ownerNotificationMuted,
    attachFilesToEmail,
    newOwnerId,
    usersToNotify,
    taskConfigs
  ) {
    const data = {
      NewStatus: newStatusId,
      fileNames: fileNames.map((file) =>
        file?.name ? file.name : file
      ) as string[],
      PostBody: postBody,
      MuteNotification: ownerNotificationMuted,
      AttachFilesToEmailNotification: attachFilesToEmail,
      NewOwnerId: newOwnerId,
      UsersToNotify: usersToNotify || [],
      TaskConfigs: taskConfigs
    };
    const changeStatusUrl = `/api/applications/${appId}/status`;
    return this.put(changeStatusUrl, data);
  }

  getStatusesForType(typeId) {
    const typeIdUrl = `/api/applications/types/${typeId}/statuses`;
    return this.get<ApplicationTypeStatusBase[]>(typeIdUrl);
  }

  getDefaultNotificationRecipients(appId: string, statusId?: string) {
    const statusQuery = statusId
      ? `?statusId=${encodeURIComponent(statusId)}`
      : '';
    const recipientsUrl = `/api/account/${appId}/default-recipients${statusQuery}`;
    return this.get<SimpleUser[]>(recipientsUrl);
  }

  getStatusGroupForType() {
    const typeIdUrl = `/api/applications/types/statuses/groups`;
    return this.get<ApplicationTypeStatusGroup[]>(typeIdUrl);
  }
}
